// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useQuery } from '@tanstack/react-query';
import { useHttpClient, type HttpClientInstance } from '@toggl/sync/http';
import type {} from '../types';
import { createQueryOptions } from '../utils/queries';
import { getEvaluationsQueryKey, getInterviewQueryKey } from './keys';
import { getEvaluations, getInterview } from './requests';

/**
 * Returns interview evaluations for the given interview and candidate
 */
export function getEvaluationsQueryOptions(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  candidateId: number,
  interviewId: number,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getEvaluationsQueryKey(
      workspaceId,
      openingId,
      candidateId,
      interviewId
    ),
    queryFn: ({ signal }) =>
      getEvaluations(
        httpClient,
        workspaceId,
        openingId,
        candidateId,
        interviewId,
        signal
      ),
    enabled,
  });
}
/**
 * Returns interview evaluations for the given interview and candidate
 */
export function useGetEvaluations(
  workspaceId: number,
  openingId: number,
  candidateId: number,
  interviewId: number,
  enabled?: boolean
) {
  const httpClient = useHttpClient();
  return useQuery(
    getEvaluationsQueryOptions(
      httpClient,
      workspaceId,
      openingId,
      candidateId,
      interviewId,
      enabled
    )
  );
}

/**
 * Returns an interview for a specific pipeline stage
 */
export function getInterviewQueryOptions(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  stageId: number,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getInterviewQueryKey(workspaceId, openingId, stageId),
    queryFn: ({ signal }) =>
      getInterview(httpClient, workspaceId, openingId, stageId, signal),
    enabled,
  });
}
/**
 * Returns an interview for a specific pipeline stage
 */
export function useGetInterview(
  workspaceId: number,
  openingId: number,
  stageId: number,
  enabled?: boolean
) {
  const httpClient = useHttpClient();
  return useQuery(
    getInterviewQueryOptions(
      httpClient,
      workspaceId,
      openingId,
      stageId,
      enabled
    )
  );
}
